import { render, staticRenderFns } from "./ExpirationsView.vue?vue&type=template&id=3528386a"
import script from "./ExpirationsView.vue?vue&type=script&lang=js"
export * from "./ExpirationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports